import CardRestrictionModal from './CardRestrictionModal';
import React, { useState } from 'react';
import dictionary from 'config/dictionary';

import styles from './prepaidCard.module.scss';

export const CardRestrictionDetails = ({ helpLinkToShow, isHeatingCard }) => {
  const [showMoreUsageDetails, setShowMoreUsageDetails] = useState(false);

  return (
    <div className={styles.restrictions}>
      <button
        className={styles.buttonAsLink}
        onClick={() => setShowMoreUsageDetails(true)}
      >
        {dictionary.prepaidCards.labels.howCanIUseThisCard}
      </button>

      {!!showMoreUsageDetails && (
        <CardRestrictionModal
          helpLinkToShow={helpLinkToShow}
          isHeatingCard={isHeatingCard}
          onClose={() => setShowMoreUsageDetails(false)}
        />
      )}
    </div>
  );
};
